export default __webpack_public_path__ + "static/media/home-background-min.6509c154.jpg";